/* eslint-disable no-unused-vars */
import { useSearchParams } from "react-router-dom";
import { debounce } from 'lodash'
import React, { useEffect, useState, useMemo } from "react";

function AppSearch({ onSearch }: { onSearch: (search: string) => void }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState('');

  // Use useMemo to create the debounced function
  const debouncedSearch = useMemo(() => {
    return debounce((value: string) => {
      if (onSearch) {
        onSearch(value);
      }

      const newSearchParams = new URLSearchParams(searchParams);
      if (value) {
        newSearchParams.set('search', value);
      } else {
        newSearchParams.delete('search');
      }
      setSearchParams(newSearchParams);
    }, 500);
  }, [onSearch, searchParams, setSearchParams]);

  // Clean up the debounced function on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    debouncedSearch(e.target.value);
  }

  useEffect(() => {
    const urlSearchQuery = searchParams.get("search");
    if (urlSearchQuery) {
      setSearchQuery(urlSearchQuery);
      if (onSearch) {
        onSearch(urlSearchQuery);
      }
    }
  }, [onSearch, searchParams]);

  return (
    <div className="flex items-center justify-center border border-primary-border bg-[#E6E6E6] p-2 rounded-full h-[2.5rem]">
      <input
        type="search"
        value={searchQuery}
        onChange={handleSearchInputChange}
        placeholder="Search for asset name, site and more"
        className="w-full h-full p-2 outline-none border-none bg-inherit placeholder:text-primary-placeholder placeholder:text-sm"
      />
    </div>
  );
}

export default AppSearch;